import React, { useState, useContext, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import { services } from "../services/api";
import LoaderComponent from "./LoaderComponent";
import { NotificacionContext } from "../context/notificacion_context";
import { useCsrfSession } from "../shared/hooks/useCsrfSession";

const ResetPassword = () => {
  let { password } = useParams();
  const navigate = useNavigate();

  const [state, setState] = useState({
    mensaje:
      "Por favor, rellene el correo electrónico que utilizó para registrarse. Se le enviará un correo electrónico con instrucciones sobre cómo restablecer su contraseña.",
    email: null,
    envioCorreo: false,
    error: false,
    cambioContraseña: false,
    mensajeCambioPassword: "",
    showPassword: false,
    setpassword: "",
    setConfirmpassword: "",
    iralogin: true,
  });

  const { showNotification } = useContext(NotificacionContext);
  const { ensureReady: ensureCsrfReady } = useCsrfSession();
  const resetPasswordAltchaRef = useRef(null);
  const submittingResetRequest = useRef(false);
  const [altchaReady, setAltchaReady] = useState(
    Boolean(customElements.get("altcha-widget"))
  );
  const challengeUrl = process.env.NODE_ENV === "development" || !process.env.REACT_APP_URLAPI
    ? "/api/altcha-challenge"
    : `${process.env.REACT_APP_URLAPI}altcha-challenge`;

  useEffect(() => {
    let active = true;
    customElements.whenDefined("altcha-widget").then(() => {
      if (active) setAltchaReady(true);
    });
    return () => { active = false; };
  }, []);

  const [loader, setLoader] = useState(false);

  const handdleRecuperarpassword = async () => {
    if (!state.email || submittingResetRequest.current) return;

    const widget = resetPasswordAltchaRef.current;
    if (!widget || typeof widget.reset !== "function" || typeof widget.verify !== "function") {
      showNotification("error", "El captcha no está listo, por favor espera un momento", null, null, 4);
      return;
    }

    submittingResetRequest.current = true;
    setLoader(true);
    try {
      try {
        await ensureCsrfReady();
      } catch {
        showNotification("error", "No se pudo preparar la sesión. Revisa tu conexión e inténtalo nuevamente.", null, null, 4);
        return;
      }

      let result;
      try {
        widget.reset();
        result = await widget.verify();
      } catch {
        showNotification("error", "No se pudo verificar la solicitud. Revisa tu conexión e inténtalo nuevamente.", null, null, 4);
        return;
      }
      if (typeof result?.payload !== "string" || !result.payload.trim()) {
        showNotification("error", "No se pudo verificar la solicitud. Inténtalo nuevamente.", null, null, 4);
        return;
      }
      const payload = new FormData();
      payload.append("email", state.email);
      payload.append("altcha", result.payload);
      const response = await services("POST", "usuarios/password-forget", payload);
      if (response) limpiar(response.data.error, response.data.create);
    } catch {
      showNotification("error", "No se pudo enviar la solicitud. Revisa tu conexión e inténtalo nuevamente.", null, null, 4);
    } finally {
      submittingResetRequest.current = false;
      setLoader(false);
    }
  };

  const handleEmail = (e) => {
    setState({ ...state, email: e.target.value });
  };

  const limpiar = (mensaje, typo, login) => {
    setState({
      ...state,
      mensaje: mensaje,
      email: "",
      envioCorreo: true,
      error: !typo,
      iralogin: login,
    });
  };

  const handdleCambiarPassword = async () => {
    if (state.setpassword.length <= 6 || state.setConfirmpassword.length <= 6) {
      showNotification(
        "error",
        "Tu contraseña debe tener minimo 6 caracteres",
        null,
        4
      );
      return;
    } else {
      const response = await services("POST", "usuarios/password-change", {
        password: state.setpassword,
        password_confirmation: state.setConfirmpassword,
        code: password,
      });

      if (response.status === 200) {
        limpiar(
          response.data.mensaje,
          response.data.update,
          response.data.update
        );
        showNotification(
          "success",
          "Su contraseña ha sido actualizada correctamente",
          "",
          null,
          4
        );
      } else {
        showNotification(
          "error",
          "Algo salió mal, intenta más tarde",
          "",
          null,
          4
        );
      }

      setLoader(false);
      navigate("/login");
    }
  };

  const handlePassword = (e) => {
    setState({ ...state, setpassword: e.target.value });
  };
  const handleConfirmPassword = (e) => {
    setState({ ...state, setConfirmpassword: e.target.value });
  };

  const handleClickShowPassword = () => {
    setState({ ...state, showPassword: !state.showPassword });
  };

  return (
    <>
      {loader && <LoaderComponent />}
      <div className="container" style={{ height: "calc(100vh - 80px)" }}>
        <div className="d-flex align-items-center justify-content-center h-100">
          <div className="card">
            {password === "password" ? (
              <>
                {altchaReady && (
                  <altcha-widget
                    ref={resetPasswordAltchaRef}
                    challenge={challengeUrl}
                    language="es-419"
                    hidebutton="true"
                    auto="off"
                    style={{ display: "none" }}
                  ></altcha-widget>
                )}
                <div className="my-3 text--morado text-bold borderBottomTitulo">
                  ¿Olvidaste tu contraseña?
                </div>

                <div
                  className="mt-3"
                  style={{
                    textAlign: "justify",
                    maxWidth: "330px",
                    color: state.envioCorreo
                      ? state.error
                        ? "red"
                        : "green"
                      : "black",
                  }}
                >
                  {state.mensaje}
                </div>
                <FormControl sx={{ m: 1, width: "35ch" }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-password">
                    Email
                  </InputLabel>
                  <Input
                    onChange={handleEmail}
                    variant="outlined"
                    value={state.email ? state.email : ""}
                    id="standard-adornment-email"
                    type="email"
                    autoComplete="email"
                    inputProps={{ "aria-label": "Correo electrónico" }}
                  />
                </FormControl>
                <div className="mt-3">
                  <button
                    type="button"
                    className="cta cta--guinda"
                    onClick={handdleRecuperarpassword}
                    disabled={loader || !state.email}
                    aria-live="polite"
                  >
                    {loader ? "Verificando…" : "Enviar"}
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="my-3 text--morado text-bold borderBottomTitulo">
                  Cambia tu contraseña
                </div>

                <div
                  className="mt-3"
                  style={{
                    textAlign: "justify",
                    maxWidth: "330px",
                    color: state.cambioContraseña
                      ? state.error
                        ? "red"
                        : "green"
                      : "black",
                  }}
                >
                  {state.mensajeCambioPassword}
                </div>

                <FormControl sx={{ m: 1, width: "25ch" }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-password">
                    Nueva Contraseña
                  </InputLabel>
                  <Input
                    variant="outlined"
                    onChange={handlePassword}
                    id="standard-adornment-password"
                    type={state.showPassword ? "text" : "password"}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {state.showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl sx={{ m: 1, width: "25ch" }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-password">
                    Confirmar Contraseña
                  </InputLabel>
                  <Input
                    variant="outlined"
                    onChange={handleConfirmPassword}
                    id="standard-adornment-password"
                    type={state.showPassword ? "text" : "password"}
                  />
                </FormControl>

                <div className="mt-3">
                  {state.iralogin ? (
                    <div
                      className="cta cta--guinda"
                      onClick={handdleCambiarPassword}
                    >
                      Enviar
                    </div>
                  ) : (
                    <div
                      className="cta cta--guinda"
                      onClick={() => {
                        navigate("/login");
                      }}
                    >
                      Ir a Login
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
